import {req} from '../utils/request';

export class Notice {
    /**
     * 我的通知列表
     * @param params {page, pagesize, is_read}
     * @returns {Promise<*>}
     */
    myList(params) {
        return req.post('user.notice/myList', params);
    }

    /**
     * 未读数量
     * @returns {Promise<*>}
     */
    unreadCount() {
        return req.post('user.notice/unreadCount');
    }

    /**
     * 通知详情
     * @param params {id}
     * @returns {Promise<*>}
     */
    detail(params) {
        return req.post('user.notice/detail', params);
    }

    /**
     * 标记已读
     * @param params {id}
     * @returns {Promise<*>}
     */
    markRead(params) {
        return req.post('user.notice/markRead', params);
    }

    /**
     * 全部标记已读
     * @returns {Promise<*>}
     */
    markAllRead() {
        return req.post('user.notice/markAllRead');
    }
}

export default new Notice();
